export * from './M32ProductTabsFeature';
